export default {
      id: "oc-bill-set-usd-usage",
      viewBox: "0 0 200 200",
      url: __webpack_public_path__ + "sprite.svg#oc-bill-set-usd",
      toString: function () {
        return this.url;
      }
    }